import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScreenType, SposobDoreczeniaType } from '../../enums/enums';
import { MainOptionButtonComponent } from '../../common/main-option-buttom/main-option-button.component';
import { NavigationService } from 'src/app/services/navigation.service';
import { DeliveryCourierFormComponent } from './delivery-courier-form/delivery-courier-form.component';
import { DeliveryPointFormComponent } from './delivery-point-form/delivery-point-form.component';
import { PageHeaderComponent } from '../../common/page-header/page-header.component';
import { MainOptionButtonsWrapperComponent } from '../../common/main-option-buttons-wrapper/main-option-buttons-wrapper.component';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-delivery-options-page',
  standalone: true,
  imports: [
    CommonModule,
    MainOptionButtonComponent,
    DeliveryCourierFormComponent,
    DeliveryPointFormComponent,
    PageHeaderComponent,
    MainOptionButtonsWrapperComponent,
  ],
  templateUrl: './delivery-options-page.component.html',
  styleUrl: './delivery-options-page.component.scss',
})
export class DeliveryOptionsPageComponent {
  ScreenType = ScreenType;
  SposobDoreczeniaType = SposobDoreczeniaType;

  stepNumber = 0;

  isSubmitLoading = signal(false);

  constructor(
    private navigationService: NavigationService,
    protected storeService: StoreService
  ) {}

  deliveryPointButtonAction() {
    this.navigationService.changeSposobDoreczeniaTo(
      SposobDoreczeniaType.DORECZENIE_DO_PUNKTU
    );
  }

  deliveryCourierButtonAction() {
    this.navigationService.changeSposobDoreczeniaTo(
      SposobDoreczeniaType.DORECZENIE_PRZEZ_KURIERA
    );
  }

  isDeliveryPoint(): boolean {
    return (
      this.storeService.getSposobDoreczeniaTyp() ===
      SposobDoreczeniaType.DORECZENIE_DO_PUNKTU
    );
  }

  isDeliveryCourier(): boolean {
    return (
      this.storeService.getSposobDoreczeniaTyp() ===
      SposobDoreczeniaType.DORECZENIE_PRZEZ_KURIERA
    );
  }

  backButtonAction() {
    this.navigationService.changeScreenTo(ScreenType.UTWORZ_PRZESYLKE);
  }

  onSubmit() {
    this.isSubmitLoading.set(true);
    this.navigationService.changeScreenTo(ScreenType.OPCJE_NADANIA);
    this.isSubmitLoading.set(false);
  }
}
